import React from 'react';

import BetBuilderIcon from '@swf/sports/components/BetBuilderIcon/BetBuilderIcon';

import styles from './BetBuilderTab.scss';

interface Props {
  name: string;
}

const BetBuilderTab: React.FC<Props> = ({ name }) => (
  <div className={styles.container}>
    <BetBuilderIcon />
    {name}
  </div>
);

export default BetBuilderTab;
